/// <amd-module name="Repos/Common/Util/Commit" />
import { format, safeSubstring } from "VSS/Core/Util/String";
import { encodeUri } from "VSS/Platform/Util/Linking";
/**
 * Gets the short summary version of the given commit comment
 *
 * @param comment Commit comment
 */
export function getShortCommitComment(comment: string, maxLength = 80, includeEllipsisForNewLine = false): string {
    if (comment) {
        comment = comment.trim();
        const newLineIndex = comment.indexOf("\n");

        let newLineFound = false;
        let ellipsisAdded = false;
        if (newLineIndex > 0) {
            comment = safeSubstring(comment, 0, newLineIndex);
            newLineFound = true;
        }
        if (comment.length > maxLength) {
            comment = safeSubstring(comment, 0, maxLength - 3).trim() + "...";
            ellipsisAdded = true;
        }

        if (!ellipsisAdded && includeEllipsisForNewLine && newLineFound) {
            comment += "...";
        }
    }
    return comment;
}

/**
 * Gets the artifact for the specified commit using the specified project and repository ids.
 *
 * @param projectId Id of the project.
 * @param repositoryId Id of the repository.
 * @param commitId Id of the commit.
 */
export function getArtifactUri(projectId: string, repositoryId: string, commitId: string): string {
    return encodeUri({
        id: format("{0}/{1}/{2}", projectId, repositoryId, commitId),
        tool: "Git",
        type: "Commit"
    });
}
